import { faClipboardList } from "@fortawesome/free-solid-svg-icons";
import UnForm from "../../../../Components/Form";
import {
    AtualizarFormulariosController,
    CadastrarFormulariosController,
} from "../../../../Controllers/Geral/Formularios/FormulariosControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { ICadastrarFormularios } from "../../../../Interfaces/Geral/Formularios/FormulariosInterface";

interface ICadastrarFormularioProps {
    formulario?: ICadastrarFormularios;
    then?: (id: number) => void;
}

export default function CadastrarEditarFormulario(
    props: ICadastrarFormularioProps
) {
    const { execute: executarFormCadastrarForm, loading } = useAsyncCallback(
        async (formDadosFormulario: ICadastrarFormularios) => {
            if (props.formulario) {
                return AtualizarFormulariosController({
                    ...formDadosFormulario,
                    ID_FORMULARIO: props.formulario.ID_FORMULARIO,
                });
            } else {
                return CadastrarFormulariosController(formDadosFormulario);
            }
        }
    );

    const handleCriarFormularioSubmit = (formData: ICadastrarFormularios) => {
        executarFormCadastrarForm({ ...formData }).then((res) => {
            props.then?.(res.id);
        });
    };

    return (
        <UnForm handleSubmit={handleCriarFormularioSubmit}>
            <div className="mb-8">
                <div className="row m-0 d-flex justify-content-center ">
                    <UnForm.Input
                        name="DS_FORMULARIO"
                        label="Nome do Formulário"
                        registerOptions={{
                            required: "Insira o Nome do Formulário",
                        }}
                        defaultValue={props.formulario?.DS_FORMULARIO}
                        wrapperClassName="col-12 col-md-12 m-0"
                    />
                </div>
            </div>

            <div className="mb-8">
                <div className="row m-0 ">
                    <UnForm.Textarea
                        registerOptions={{
                            required: "Insira a Descrição do Formulário",
                        }}
                        name="DS_INFORMACOES"
                        label="Descrição do Formulário"
                        noRezise
                        rows={3}
                        defaultValue={props.formulario?.DS_INFORMACOES}
                        wrapperClassName="col-12 col-md-12 m-0"
                    />
                </div>
            </div>
            <div className="mb-8">
                <div className="row m-0 ">
                    <UnForm.Switch
                        color="primary"
                        wrapperClassName="ml-4 mt-2"
                        label="NPS ?"
                        labelPosition="top"
                        type="checkbox"
                        name="FL_NPS"
                        defaultChecked={props.formulario?.FL_NPS}
                    />
                </div>
            </div>

            <UnForm.SubmitButton
                color={props.formulario ? "primary" : "success"}
                wrapperClassName="w-100 mt-8 col-12"
                className="w-100"
                icon={faClipboardList}
                loading={loading}
                disabled={loading}
                loadingSize={"sm"}
            >
                {props.formulario ? "Editar Formulário" : "Criar Formulário"}
            </UnForm.SubmitButton>
        </UnForm>
    );
}
